import React from 'react'
import Navbar from "../../components/nav/Navbar"
import "./contact.css"
import thumb from "../../assets/images/thumb.png" 
import { motion } from 'framer-motion'
import Navbarmobile from '../../components/navbarmobile/Navbarmobile'
const Contact = () => {
    const [isSubmitted, setIsSubmitted] = React.useState(false)
    const handleSubmit = (e) => {
        e.preventDefault()
        setIsSubmitted(true)
        setTimeout(()=>{
            setIsSubmitted(false)
        }, 5000)
    }
  return (
    <div className="contact">
        <Navbarmobile/>
        <Navbar/>
        <div className="contact-wrapper">
            <header className="contact-header">
                <motion.h1
                    initial={{y: -200}}
                    animate={{y: 0}}
                    transition={{type: "spring", delay: 1.6}}
                >Let's have a talk</motion.h1>
            </header>
            <main className="contact-body">
                <div className="topics-container">
                    <motion.h1 
                    initial={{scale: 0}}
                    animate={{scale: 1}}
                    transition={{ease: "easeInOut", duration: 0.8}}>Subjects</motion.h1>
                    <motion.p
                         initial={{scale: 0}}
                         animate={{scale: 1}}
                         transition={{ease: "easeInOut", duration: 0.8, delay: 1}}
                    >Have a project in mind you want me to work on ?</motion.p>
                    <motion.p
                        initial={{scale: 0}}
                        animate={{scale: 1}}
                        transition={{ease: "easeInOut", duration: 0.8, delay: 1.2}}
                    >Hire me into your company.</motion.p>
                    <motion.p
                        initial={{scale: 0}}
                        animate={{scale: 1}}
                        transition={{ease: "easeInOut", duration: 0.8, delay: 1.4}}
                    >Want to have a chat ?</motion.p>
                    <motion.p
                        initial={{scale: 0}}
                        animate={{scale: 1}}
                        transition={{ease: "easeInOut", duration: 0.8, delay: 1.6}}
                    >Front-End Developer with a proven ability to collaborate
                    effectively with senior developers while spending extra time to
                    be mentored. Enjoy working closely with team members to
                    ensure workloads are effectively redirected to bottlenecks.
                    With a passion for both personal growth and for software
                    development, Ready to apply my passion for coding to a
                    talented development team to develop quality web
                    applications.
                    </motion.p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="name-container">
                        <motion.div className="input-name-item"
                            initial={{x: "100vw"}}
                            animate={{x: 0}}
                            transition={{ease: "easeInOut", duration: 0.8}}
                        >
                            <input type="text" placeholder="Firstname"/>
                            <div className="borderbtm"></div>
                        </motion.div>
                        <motion.div className="input-name-item"
                            initial={{x: "100vw"}}
                            animate={{x: 0}}
                            transition={{ease: "easeInOut", duration: 0.8, delay: 1}}
                        >
                            <input type="text" placeholder="Lastname"/>
                            <div className="borderbtm"></div>
                        </motion.div>
                    </div>
                    <motion.div className="input-item"
                        initial={{x: "100vw"}}
                        animate={{x: 0}}
                        transition={{ease: "easeInOut", duration: 0.8, delay: 1.2}}
                    >
                        <input type="text" placeholder="Company name"/>
                        <div className="borderbtm"></div>
                    </motion.div>
                    <motion.div className="input-item"
                        initial={{x: "100vw"}}
                        animate={{x: 0}}
                        transition={{ease: "easeInOut", duration: 0.8, delay: 1.4}}
                    >
                        <input type="text" placeholder="Email address"/>
                        <div className="borderbtm"></div>
                    </motion.div>
                    <motion.div className="input-item"
                        initial={{x: "100vw"}}
                        animate={{x: 0}}
                        transition={{ease: "easeInOut", duration: 0.8, delay: 1.6}}
                    >
                        <input type="text" placeholder="Subject"/>
                        <div className="borderbtm"></div>
                    </motion.div>
                    <motion.div className="textarea-item"
                        initial={{x: "100vw"}}
                        animate={{x: 0}}
                        transition={{ease: "easeInOut", duration: 0.8, delay: 1.8}}
                    >
                        <textarea type="text" placeholder="Message"/>
                        <div className="borderbtm"></div>
                    </motion.div>
                    <div className="button-container">
                        <motion.button className="sendbtn" type="submit"
                            initial={{y: 200}}
                            animate={{y: 0}}
                            transition={{type: "spring", duration: 0.8, delay: 2}}
                        >send message</motion.button>
                        {isSubmitted && 
                            <div className="confirmation-message">
                                <img src={thumb} alt="thumbs up" />
                                <p>have received your message will get back to you shortly...</p>
                            </div>
                        }
                    </div>
                </form>
            </main>
        </div>
    </div>
  )
}

export default Contact